import { API } from "@project/shared"

export const updateChildPassword = async (values: any) => {
  return API.patch(`/child-parent/update-child-password`, values)
}
